var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProtect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    width: 16,
    viewBox: "0 0 1140.000000 1280.000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#B8C1CF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5540 12724 c-644 -313 -1533 -685 -2170 -906 -1183 -411 -2198 -631 -3133 -679 l-238 -12 6 -26 c2 -14 45 -273 95 -576 197 -1206 345 -2033 504 -2820 374 -1859 762 -3105 1285 -4130 367 -720 786 -1301 1326 -1840 602 -601 1342 -1129 2302 -1639 l182 -97 183 97 c2289 1214 3474 2611 4258 5019 417 1280 732 2764 1205 5680 25 154 48 292 51 306 l5 26 -143 7 c-381 18 -653 46 -998 101 -1289 207 -2774 710 -4423 1499 -76 36 -139 66 -140 65 -1 0 -72 -34 -157 -75z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtect);
export default __webpack_public_path__ + "static/media/protect.1e919ce6.svg";
export { ForwardRef as ReactComponent };